import { useQuery, UseQueryResult } from "react-query";
import { getVisitReasonsLookup } from "services/visitReasons";
import { VisitReasonApi } from "services/visitReasons/types";

/** Clé partagée : l'écran de gestion l'invalide après chaque modification. */
export const VISIT_REASONS_LOOKUP_KEY = ["visit-reasons-lookup"];

/**
 * Motifs de visite actifs, triés, pour l'ajout en file et la correction du
 * motif. Liste courte : chargée d'un coup et mise en cache 5 min.
 */
export function useVisitReasonsLookup(): UseQueryResult<VisitReasonApi[]> {
  return useQuery<any, unknown, VisitReasonApi[]>(
    VISIT_REASONS_LOOKUP_KEY,
    () => getVisitReasonsLookup(),
    {
      staleTime: 5 * 60 * 1000,
      select: (result: any) => (result?.ok ? result.data ?? [] : []),
    }
  );
}

export default useVisitReasonsLookup;
